import React from "react";
import { object, shape, string, arrayOf } from "prop-types";
import EventsLandingPage from "../../organisms/EventsLandingPage";
import { useIsMobile } from "../../hooks/useIsMobile";

import "./workshops-landing-page.m.css";

export const WorkshopsLandingPage = ({ data, ...props }) => {
  const isMobile = useIsMobile();

  return (
    <EventsLandingPage
      data={data}
      eventType="workshops"
      className="workshops-landing-page"
      isMobile={isMobile}
      {...props}
    />
  );
};

WorkshopsLandingPage.propTypes = {
  data: shape({
    collection: shape({
      name: string,
      summary: string,
      "hero-image-s3-key": string,
      "hero-image-metadata": object
    }),
    upcomingWorkshops: arrayOf(
      shape({
        id: string,
        headline: string,
        subheadline: string,
        "hero-image-s3-key": string,
        "hero-image-metadata": object,
        slug: string,
        attributes: shape({
          "event-date": string,
          "event-location": string
        })
      })
    ),
    previousWorkshops: arrayOf(
      shape({
        id: string,
        headline: string,
        subheadline: string,
        "hero-image-s3-key": string,
        "hero-image-metadata": object,
        slug: string,
        attributes: shape({
          "event-date": string,
          "event-location": string
        })
      })
    )
  })
};

export default WorkshopsLandingPage;